import type { PropsWithChildren } from 'react';
import React from 'react';
import { Header } from '../abc/header';
import { Footer } from '../abc/footer';
import { FullPageHeightWrapper } from '../../component_library/components/Grid';
import { useGetTheme } from '../../hooks/use-get-theme';

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  const theme = useGetTheme();

  return (
    <FullPageHeightWrapper theme={theme} sx={{ background: 'unset' }}>
      <Header />
      {/* Sometimes the footer renders earlier than everything else,
          can't figure out how to stop it.
          So putting min height on the <main> here at least makes the footer
          render towards the bottom of the page instead of the top: */}
      <main style={{ minHeight: 'calc(100dvh - 400px)' }}>{children}</main>
      <Footer />
    </FullPageHeightWrapper>
  );
};

export default Layout;
